import React from 'react';
import PropTypes from 'prop-types';

import styles from './DiscountPrice.css';

export default function DiscountPrice({ priceBeforeDiscount, yearlyPrice }) {
  return (
    <div className={styles.discount}>
      <span className={styles.originalPrice}>${priceBeforeDiscount}</span> $
      {yearlyPrice} <span className={styles.perYear}>per year</span>
    </div>
  );
}

DiscountPrice.propTypes = {
  priceBeforeDiscount: PropTypes.number.isRequired,
  yearlyPrice: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/modules/Pricing/DiscountPrice/index.js